module.exports = __webpack_public_path__ + "e4144825ef9f209771fd3a6e9672fd7e.png";